export default {
  INTERACTIVE_MAP: 'interactive-map',
  CUSTOM_MAP: 'project-map',
}
